import { PatientInsuranceStatus } from '../model/patient-insurance'

export function getPatientInsuranceStatusText(status?: PatientInsuranceStatus): string {
  switch (status) {
    case PatientInsuranceStatus.Active:
      return 'common.active'
    case PatientInsuranceStatus.Inactive:
      return 'common.inactive'
    case PatientInsuranceStatus.NotVerified:
      return 'common.not-verified'
    default:
      return 'common.unknown'
  }
}
